import React from 'react';
import { cx } from './cx';

export interface AdminPageHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  /** nút chính bên phải (AdminButton elevated) và các nút phụ */
  actions?: React.ReactNode;
  className?: string;
}

// Đầu trang không bọc thẻ: h1 24px + mô tả 14px bên trái, nút bên phải, canh đáy.
export const AdminPageHeader = ({ title, description, actions, className }: AdminPageHeaderProps) => (
  <div className={cx('adm-page-header', className)}>
    <div className="adm-page-header__text">
      <h1 className="adm-page-header__title">{title}</h1>
      {description && <p className="adm-page-header__desc">{description}</p>}
    </div>
    {actions && <div className="adm-page-header__actions">{actions}</div>}
  </div>
);

export default AdminPageHeader;
